module.exports = __webpack_public_path__ + "static/media/KMH_5406.7a259602.jpg";